import UnfoldLogo from '../assets/unfold-logo.svg';
import { styled, Theme, Colors } from '@unfold/theme';

export const StyledLogo = styled(UnfoldLogo)`
  path {
    fill: ${({ theme }): string =>
      theme.name === Theme.LIGHT ? Colors.BLACK : Colors.WHITE};
  }
`;
